module.exports = __webpack_public_path__ + "img/longhouse64_ua.d2043e1f.webp";